module.exports = __webpack_public_path__ + "static/media/klima-13.95084159.jpg";